import { http } from '../../core';
import Config from "../../app.config";
const RequestbaseURL = http.create({ baseURL: Config.BASE_API });

export function userRegister(params) { // 注册用户
    return RequestbaseURL.post('/usercenter/sso/operator/www/v1/user/register', params)
}

export function userSendemail(params) { // 发送验证码
    return RequestbaseURL.get('/usercenter/sso/operator/www/v1/user/sendemail', params)
}

export function userResetpassword(params) { // 重置密码
    return RequestbaseURL.post('/usercenter/sso/operator/www/v1/user/resetpassword', params)
}



